// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

const defaultSettings = {
  visibleClass: 'is-visible',
  hiddenClass: 'is-hidden',
  popupClasses: [
    'c-track-map__track-popup',
  ],
};

class TrackMap {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;
    this.pins = el.querySelectorAll('#pins > *');
    this.track = el.querySelector(settings.track);
    this.tickets = document.querySelectorAll(settings.ticket);

    // Set settings
    this.settings = { ...settings, ...defaultSettings };
    this.settings.popupClasses = this.settings.popupClasses.concat([this.settings.popup.replace('.', '')]);
  }

  init = () => {
    this.createPopups();

    this.tickets.forEach((el) => {
      el.addEventListener('mouseenter', (e) => this.showPinPopup(e));

      el.addEventListener('mouseleave', () => this.hideAll());

      // mobile
      el.addEventListener('touchstart', (e) => {
        this.hideAll();
        this.showPinPopup(e);
      });
    });
  };

  createPopups = () => {
    this.tickets.forEach((el) => {
      const locationId = el.getAttribute('data-location-id');
      const location = el.getAttribute('data-location');

      const pin = [].slice.call(this.pins)
        .find((p) => p.id === locationId);
      if (!pin) return;

      const popup = document.createElement('div');
      popup.id = locationId;
      popup.innerHTML = location;

      this.settings.popupClasses.forEach((c) => popup.classList.add(c));

      this.track.appendChild(popup);
    });

    this.popups = this.container.querySelectorAll(this.settings.popup);
  };

  showPinPopup = (e) => {
    const locationId = e.target.getAttribute('data-location-id');

    const popup = [].slice.call(this.popups)
      .find((p) => p.id === locationId);
    if (!popup) return;

    const pin = [].slice.call(this.pins)
      .find((p) => p.id === locationId);
    if (!pin) return;

    const pinBounds = pin.getBoundingClientRect();

    const trackBounds = this.track.getBoundingClientRect();

    popup.style.top = `${(pinBounds.top - trackBounds.top) + (pinBounds.height / 2)}px`;

    let left = (pinBounds.left - trackBounds.left - popup.offsetWidth) + (pinBounds.width / 2);
    if (left < 0) {
      left = (pinBounds.left - trackBounds.left) + (pinBounds.width / 2);
    }

    popup.style.left = `${left}px`;

    this.pins.forEach((p) => p.classList.add(this.settings.hiddenClass));
    pin.classList.remove(this.settings.hiddenClass);
    popup.classList.add(this.settings.visibleClass);
  };

  hideAll = () => {
    this.pins.forEach((p) => p.classList.remove(this.settings.hiddenClass));
    this.popups.forEach((p) => p.classList.remove(this.settings.visibleClass));
  };

  isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0
      && rect.left >= 0
      && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
}

export default (settings) => initialiser(settings, TrackMap);
